export default {
	state: {
		produtoSelecionado: {}
	},
	getters: {
		"produtoSelecionado": state => state.produtoSelecionado
	},
	mutations: {
		setProdutoSelecionado(state, payload) {
			state.produtoSelecionado = payload
		}
	},
	actions: {
		atualizarEstadoProdutoSelecionado({ commit }, payload) {
			commit('setProdutoSelecionado', payload)
		}
	}
};